import { AllStatements } from "./AllStatements";
import { Expandable } from "./Expandable";
import { DownloadDoc } from "./DownloadDoc";
import { subMonths } from "date-fns";

export const Documents = () => {
    const month = subMonths(new Date(), 1);

    return (
        <div className="document-container">
            <h1>Statements & Documents</h1>

            <div style={{ padding: "20px 0" }}>
                <h3 style={{ padding: "10px 0" }}>Most Recent</h3>
                <div className="download-doc-container ">
                    <DownloadDoc month={month} />
                </div>
            </div>

            <div style={{ padding: "20px 0" }}>
                <h3 style={{ padding: "10px 0" }}>View All</h3>
                <div>
                    <Expandable title={"Statements"} component={<AllStatements />} />
                    <Expandable
                        title={"Tax Statements"}
                        component={
                            <div>
                                <p>You have no tax statements available.</p>
                            </div>
                        }
                    />
                    <Expandable
                        title={"Notifications and Letters"}
                        component={
                            <div>
                                <p>You have no Notifications and Letters available.</p>
                            </div>
                        }
                    />
                    <Expandable
                        title={"Other Account Documents"}
                        component={
                            <div>
                                <p>You have no other documents available.</p>
                            </div>
                        }
                    />
                </div>
            </div>

            <div style={{ padding: "50px 0 0 0" }}>
                <h3>Manage your Paperless Settings</h3>
                <p>
                    Get safe, secure statements right in your desktop Tax statements can only be downloaded because they
                    contain your Tax Identification Number (TIN), Social Security Number (SSN) and/or full account
                    number.To view statements online in PDF format, you will need Adobe Reader software 6.0 or higher.
                    If you don’t have Adobe Reader installed on your computer, you can download Adobe Reader now for
                    free.
                </p>
            </div>
        </div>
    );
};
